import { useEffect, useState } from "react";
import "./MusicLoader.scss";

const DEFAULT_STEPS = [
  "Reading your taste…",
  "Consulting the composers…",
  "Cross-referencing four centuries…",
  "Tuning the orchestra…",
  "Classifying your finds…",
];

// A playful equalizer + cycling status line, for slow AI/API waits.
export default function MusicLoader({ steps = DEFAULT_STEPS, compact = false }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % steps.length), 1600);
    return () => clearInterval(t);
  }, [steps.length]);

  return (
    <div className={`mloader${compact ? " mloader--compact" : ""}`} role="status" aria-live="polite">
      <div className="mloader__bars" aria-hidden="true">
        {Array.from({ length: 7 }).map((_, b) => (
          <span key={b} style={{ "--b": b }} />
        ))}
      </div>
      <p className="mloader__caption">{steps[i]}</p>
    </div>
  );
}
